import { BLACK, PRIMARY_COLOR } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

export const typographySx = {
  title: {
    color: PRIMARY_COLOR[70],
    fontFamily: PRIMARY_FONT[700],
    fontSize: '24px',
    mb: 3,
  },
  header: {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '18px',
    color: BLACK[100],
    mb: 2,
  },
  sectionHeader: {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '20px',
    color: BLACK[100],
    mb: 2,
  },
  subHeader: {
    fontFamily: PRIMARY_FONT[300],
    fontSize: '12px',
    color: BLACK[70],
    textTransform: 'uppercase',
    mb: 1,
  },
  text: {
    fontFamily: PRIMARY_FONT[400],
    fontSize: '14px',
    color: BLACK[100],
    mb: 1,
  },
  value: {
    fontFamily: PRIMARY_FONT[500],
    fontSize: '16px',
    color: BLACK[100],
    wordBreak: 'break-word',
    mb: 1,
  },
};

export const confirmModalSx = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: (smallScreen) => ({
    position: 'relative',
    width: smallScreen ? '90vw' : '880px',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    maxHeight: '90vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  }),
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 4,
    pt: 3,
    pb: 2,
  },
  closeButton: {
    color: BLACK[60],
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: BLACK[30],
  },
  scrollArea: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    px: 4,
    py: 3,
  },
  footer: {
    px: 4,
    py: 3,
  },
  sectionSpacing: { mb: 4 },
  weekPill: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: PRIMARY_COLOR[70],
    borderRadius: 2,
    px: 2.5,
    py: 1,
    mb: 2,
  },
  weekPillText: {
    fontFamily: PRIMARY_FONT[500],
    fontSize: '12px',
    color: BLACK[0],
  },
  weekCard: {
    borderRadius: 3,
    backgroundColor: BLACK[10],
    p: 2.5,
  },
  weekRow: {
    display: 'flex',
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: { xs: 0.5, sm: 1 },
    py: 1.25,
  },
  weekRowDate: {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '16px',
    color: BLACK[100],
    minWidth: { xs: '100%', sm: '240px' },
  },
  weekRowTime: {
    fontFamily: PRIMARY_FONT[300],
    fontSize: '16px',
    color: BLACK[100],
    flex: 1,
    textAlign: { xs: 'left', sm: 'center' },
    minWidth: { xs: '100%', sm: 'auto' },
  },
  weekRowOpenings: {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '16px',
    color: PRIMARY_COLOR[70],
    minWidth: { xs: '100%', sm: '160px' },
    textAlign: { xs: 'left', sm: 'right' },
  },
  weekTotalRow: {
    borderTop: '2px dashed rgba(0,0,0,0.16)',
    mt: 1.5,
    pt: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  weekTotalLabel: {
    fontFamily: PRIMARY_FONT[400],
    fontSize: '18px',
    color: BLACK[70],
  },
  weekTotalValue: {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '18px',
    color: PRIMARY_COLOR[70],
  },
  totalPositionsSummaryCard: {
    borderRadius: 3,
    backgroundColor: PRIMARY_COLOR[10],
    p: 3,
  },
  totalPositionsSummaryTitle: {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '18px',
    color: PRIMARY_COLOR[70],
    mb: 2,
  },
  totalPositionsSummaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 3,
    flexWrap: 'wrap',
  },
  totalPositionsSummaryCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
    minWidth: '240px',
  },
  totalPositionsSummaryColRight: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
    minWidth: '240px',
    alignItems: { xs: 'flex-start', sm: 'flex-end' },
    textAlign: { xs: 'left', sm: 'right' },
    marginLeft: 'auto',
  },
  totalPositionsSummaryLabel: {
    fontFamily: PRIMARY_FONT[400],
    fontSize: '12px',
    color: PRIMARY_COLOR[70],
  },
  totalPositionsSummaryValue: {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '18px',
    color: PRIMARY_COLOR[70],
  },
  emptyState: {
    mb: 4,
    px: 1,
  },
  footerActions: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 2,
  },
  editButton: {
    color: '#000000',
    backgroundColor: '#ffffff',
    border: '1px solid #cccccc',
    borderRadius: '4px',
    padding: '12px 24px',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  postButton: {
    backgroundColor: PRIMARY_COLOR[70],
    color: '#ffffff',
    borderRadius: '4px',
    padding: '12px 24px',
    '&:hover': {
      backgroundColor: PRIMARY_COLOR[80],
    },
  },
};
